import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { AvailableTimesResponse } from '@interfaces/professional-booking';


@Injectable({
    providedIn: 'root'
})
export class ServicePageService {
    constructor(private http: HttpClient) { }

    getProduct(slug): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/service/${slug}`);
    }

    getDisabledDates(id, start, end): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/products/get-disabled-dates/${id}`, { start, end });
    }

    getAvailableTimes(id: string, date: string): Observable<AvailableTimesResponse> {
        return this.http.post<AvailableTimesResponse>(`${environment.apiUrl}/products/get-available-times/${id}`, { date });
    }
}
